import { render, staticRenderFns } from "./homepage3.vue?vue&type=template&id=9a06ab82&scoped=true&"
import script from "./homepage3.vue?vue&type=script&lang=js&"
export * from "./homepage3.vue?vue&type=script&lang=js&"
import style0 from "./homepage3.vue?vue&type=style&index=0&id=9a06ab82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a06ab82",
  null
  
)

export default component.exports